import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["teamMode", "team", "organization"]),
  },

  methods: {
    getUserTeamApiUrl(url, opts = {}) {
      if (this.teamMode) {
        Object.assign(opts, {
          organization: this.organization.slug,
          team: this.team.slug,
        });

        url = "organization/{organization}/team/{team}/" + url;
      }

      return this.$apiUrl(url, opts);
    },

    getUserTeamAppUrl(url, opts = {}) {
      if (this.teamMode) {
        Object.assign(opts, {
          organization: this.organization.slug,
          team: this.team.slug,
        });

        url = "organization/{organization}/team/{team}/" + url;
      }

      return this.$appUrl(url, opts);
    },
  },
};
